import React, { forwardRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import BtnSelect from "../../../UI/Buttons/BtnSelect";
import Card from '../../../UI/Card';
import { studyGroupsApi } from '../../../../utils'

import classes from "./CourseBuildCompletion.module.css";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";


const CourseBuildCompletion = forwardRef(({ studyGroup, handleChangeStudyGroupDescription, setCourseComplete, newCourse, setValid, newNationalStudyGroup }, ref) => {
    const texts = useSelector(state => state.translate.texts);
    const direction = useSelector(state => state.translate.direction);
    const uiData = useSelector((state) => state.general.uiData);
    const homeUrl = useSelector((state) => state.application.homeUrl);
    const [courseVideoLink, setCourseVideoLink] = useState()
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        setValid && setValid(true)
        if (newCourse)
            setCourseComplete && setCourseComplete(true);
        // in New Course   newCourse

        changeCourseName(studyGroup?.description)
    }, [])

    useEffect(() => {
        if (uiData)
            setCourseVideoLink(uiData.courseBuildCompletionVideoLink)
    }, [uiData])

    const debounce = (func, delay) => {
        let debounceTimer;
        return function () {
            const context = this;
            const args = arguments;
            clearTimeout(debounceTimer);
            debounceTimer =
                setTimeout(() => func.apply(context, args), delay);
        }
    }

    async function changeCourseName(newName) {
        if (newName !== '') {
            let data = { studyGroupId: studyGroup.id, courseId: studyGroup.courseId, name: newName, allowSelfRegister: newNationalStudyGroup ? true : false }
            studyGroupsApi.studyGroupsUpdatePost({ studyGroupUpdateInput: data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.studyGroupsUpdateError, error: error, statusCode: response?.statusCode, message: "studyGroupsUpdatePost " + error.message, level: 2, component: "CourseBuildCompletion", line: 42 }))
                }
            })
        }
    }
    const handleChange = (event) => {
        event.persist();
        console.log("Something is changed in the textarea", event.target.value);
        handleChangeStudyGroupDescription(event.target.value);
        changeCourseName(event.target.value)
    }

    let optimisedHandleChange = debounce(handleChange, 700);

    return (
        <div className={`${classes[direction]} ${classes.CourseFinish}`}>
            {/* למה צריך את זה?? */}
            {/* <p>{texts.studySubjects}</p> */}
            <div className={classes.TextArea}>
                <div className={classes.CourseFinishText}>{newCourse || newNationalStudyGroup ? texts.completionCreatingCourse : texts.completionEditingCourse}</div>
                <div className={classes.CourseDetailsWrapper}>
                    <div className={classes.CanRename}>{texts.canRename}</div>
                    <div key="renameText" className={classes.WrapInput}>
                        <input type='text'
                            defaultValue={studyGroup?.description}
                            // placeholder={studyGroup.description}
                            name="renameText"
                            className={classes.Input}
                            onChange={optimisedHandleChange}
                        />
                        <div className={classes.ArrowIcon}></div>
                    </div>
                    <div className={classes.Card}>
                        <Card>
                            <div className={classes.Top} style={{ backgroundColor: studyGroup?.color }}></div>
                            <div className={classes.CourseDetails}>
                                <div className={classes.CourseName}>{studyGroup?.subject}</div>
                                <div className={classes.CourseDescription}>{studyGroup?.description}</div>
                            </div>
                        </Card>
                    </div>
                    {newCourse && <BtnSelect onClick={() => navigate(`${homeUrl}/courses/${studyGroup.id}`, { state: { fetchCoursesData: true } })} dropStyle={{ backgroundColor: '#73DED8', border: 'none', fontSize: '14px', fontWeight: '700' }}>{texts.editThisCourse}</BtnSelect>}
                </div>
            </div>
            {newCourse ?
                <div className={classes.VideoArea}>
                    <div className={classes.Video}>
                        <iframe title="courseVideo" width="612" height="408" src={courseVideoLink} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                    </div>
                    <div className={classes.VideoDescription}>{texts.courseVideoDescription}</div>
                </div> :
                <div className={classes.Map}></div>}
        </div>)
})

export default CourseBuildCompletion;
